module.exports = __webpack_public_path__ + "static/media/u50_premium_contract1.bc9e8238.webp";